<template>
  <icon-base
    class="cursor-pointer"
    :icon="IconStatusConfigure"
    width="40"
    height="40"
    data-cy="wfb-statuses-sidebar-open-button"
    @click="toggleStatusesSidebar"
  />
</template>

<script setup lang="ts">
import { useStore } from "vuex";

import IconStatusConfigure from "@/components/icons/IconStatusConfigure.vue";

const { commit } = useStore();

const toggleStatusesSidebar = () => {
  commit("workflows/toggleStatusesSidebar");
};
</script>
